import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Input,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { setUyariAdet } from 'src/utils/storage/NavBarAdet';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  }
}));
function Todos({ className, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('warning_center');
  const [todos, setTodos] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [todosData, setTodosData] = useState([]);
  const SessionUser = getUser();
  const history = useHistory();

  let todosData1 = [];
  const onChange = event => {
    todosData1 = todos.filter(function(item) {
      return (
        item.ACIKLAMA.toLowerCase().indexOf(
          event.target.value.toLowerCase()
        ) !== -1
      );
    });
    setTodosData(todosData1);
    event.persist();
  };

  const BirimKodu = SessionUser.ServiceShopId;
  const TeknisyenKodu = SessionUser.TechnicianId;

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      axios
        .get(`/GetArtemisTodoList/${BirimKodu}/${TeknisyenKodu}/0/0`)
        .then(response => {
          if (mounted) {
            const Deger = response.data;
            if (Deger.length === 0) {
              setTodos([]);
              setTodosData([]);
            } else {
              setTodos(Deger);
              setTodosData(Deger);
            }
            const Adet = response.data.length;
            setUyariAdet(Adet);
            setLoading(false);
          }
        })
        .catch(error => {
          setUyariAdet(0);
          setLoading(false);
        });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [BirimKodu, TeknisyenKodu]);

  return (
    <div>
      {window.navigator.onLine && (
        <div className={clsx(classes.root, className)}>
          <Card>
            <Paper className={classes.search} elevation={1}>
              <SearchIcon className={classes.searchIcon} />
              <Input
                className={classes.searchInput}
                disableUnderline
                onChange={event => onChange(event)}
                placeholder={t('Arama_Yap')}
              />
            </Paper>
            <CardHeader title={t('cagri_Merkezi_Uyarilar')} />
            <Divider />
            {Loading ? (
              <Backdrop className={classes.backdrop} open={Loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (
              <div />
            )}
            <CardContent className={classes.content}>
              <List className={classes.root}>
                {/* {todosData.sort((a, b) => { return a.OKUNDU - b.OKUNDU }).sort((a, b) => { return a.TARIH - b.TARIH }).map(log => ( */}
                {todosData.map(log => (
                  <div key={log.SM_ID}>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <div align="center">
                          <Typography
                            component="span"
                            variant="h3"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {log.GUN}
                          </Typography>
                          <br />
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {log.AY}
                          </Typography>
                          {/* <br />
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className={classes.inline}
                            color="textPrimary">{log.YIL}
                          </Typography> */}
                          <br />
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {log.SAAT}
                          </Typography>
                          <br />

                          <Typography component="span" variant="caption">
                            {log.OKUNDU ? (
                              <CheckCircleIcon style={{ color: green[500] }} />
                            ) : (
                              <div />
                            )}
                          </Typography>
                        </div>
                      </ListItemAvatar>
                      <ListItemText
                        onClick={() =>
                          history.push(`/WorkOrder/${log.FIS_NO}/summary`)}
                        primary={`${log.FIS_NO} ${log.Musteri}`}
                        secondary={
                          <>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {t('Arama_Tekrari')}:{log.ARAMA_SAYISI}
                            </Typography>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {log.BASVURU_NEDENI}
                            </Typography>
                            <Typography
                              component="span"
                              variant="body2"
                              color="textPrimary"
                            >
                              {log.ACIKLAMA}
                            </Typography>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {t('Arayan')} : ({log.ARAYAN_TEL.substring(0, 3)}
                              )***
                              {log.ARAYAN_TEL.substring(8, 10)}
                            </Typography>
                          </>
                        }
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </div>
                ))}
              </List>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
}

Todos.propTypes = {
  className: PropTypes.string
};

export default Todos;
